<script lang="ts">
	import type { LayoutData } from './$types'
	import { goto } from '$app/navigation'
	import Header from '$lib/components/Header/Header.svelte'
	import { SvelteToast } from '@zerodevx/svelte-toast'
	import UpgradeToPaid from '$lib/components/UpgradeToPaid.svelte'
	import { showUpgradeDialog } from '$lib/stores/upgrade'
	import { user, likes, bookmarks, profile } from '$lib/stores/userData'
	import '../app.css'
	import type { Profile } from '$lib/types/profile'
	import pageSettings from '$lib/stores/pageSettings'

	export let data: LayoutData
	
	$user = data.user?.id 
	$profile = data.profile ?? {} as Profile
	$likes = data.likes ?? []
	$bookmarks = data.bookmarks ?? []
	$pageSettings = data.ps

	$: upgradeDialog = $showUpgradeDialog ? UpgradeToPaid : undefined
	
</script>

<toast class="font-semibold text-center text-lg">
	<SvelteToast />
</toast>

<svelte:component this={upgradeDialog} open={$showUpgradeDialog} />

<!-- <Analytics /> -->

<div class="h-screen min-h-screen sm:pt-12">
	{#if !data.noheader}
		<Header on:login={() => goto('/login')} on:signup={() => goto('/signup')} />
	{/if}

	<main class="">
		<slot />
	</main>
</div>
